import {
    Pagination,
    PaginationContent,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "@patient-watch/ui/pagination";

interface CardTablePaginationProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

function pageItems(totalPages: number, current: number): number[] {
    if (totalPages <= 5) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const start = Math.max(1, Math.min(current - 1, totalPages - 4));
    return Array.from({ length: 5 }, (_, i) => start + i);
}

/** Compact pagination under card tables. Hidden when everything fits on one page. */
export function CardTablePagination({ page, totalPages, onPageChange }: CardTablePaginationProps) {
    if (totalPages <= 1) return null;

    return (
        <div className="flex justify-center pt-3">
            <Pagination>
                <PaginationContent>
                    <PaginationItem>
                        <PaginationPrevious
                            href="#"
                            aria-disabled={page <= 1}
                            className={page <= 1 ? "pointer-events-none opacity-50" : undefined}
                            onClick={(event) => {
                                event.preventDefault();
                                onPageChange(Math.max(1, page - 1));
                            }}
                        />
                    </PaginationItem>
                    {pageItems(totalPages, page).map((item) => (
                        <PaginationItem key={item}>
                            <PaginationLink
                                href="#"
                                isActive={page === item}
                                onClick={(event) => {
                                    event.preventDefault();
                                    onPageChange(item);
                                }}
                            >
                                {item}
                            </PaginationLink>
                        </PaginationItem>
                    ))}
                    <PaginationItem>
                        <PaginationNext
                            href="#"
                            aria-disabled={page >= totalPages}
                            className={page >= totalPages ? "pointer-events-none opacity-50" : undefined}
                            onClick={(event) => {
                                event.preventDefault();
                                onPageChange(Math.min(totalPages, page + 1));
                            }}
                        />
                    </PaginationItem>
                </PaginationContent>
            </Pagination>
        </div>
    );
}

export const CARD_TABLE_PAGE_SIZE = 10;
